import * as types from './types'
import Auth from '@kenetto/kenetto-redux-authenticator'

import { configAuth, basePathConfiguration, configurationNameSpace } from '../../config'

const auth = new Auth(configAuth(), basePathConfiguration, configurationNameSpace)

export const loginRequest = (referrer) => {
  console.log(referrer)
  auth.login(referrer)
  return {
    type: types.LOGIN_REQUEST,
    payload: referrer
  }
}

export const handleAuthentication = () => {
  return dispatch => {
    try {
      auth.handleAuthentication(loginSuccess, dispatch)
    } catch (e) {
      console.log(e)
    }
  }
}

export const getProfile = () => {
  return dispatch => {
    if (auth.isAuthenticated()) {
      auth.getProfile().then(profile => {
        dispatch({ type: types.GET_PROFILE, payload: { profile } })
      })
    } else {
      dispatch({ type: types.LOGIN_REQUEST })
    }
  }
}

export const loginSuccess = (profile, returnUrl) => ({
  type: types.LOGIN_SUCCESS,
  payload: { profile, returnUrl }
})

export const loginError = error => ({
  type: types.LOGIN_ERROR,
  error
})

export const logout = () => {
  auth.logout()
  return {
    type: types.LOGOUT_SUCCESS
  }
}

export { auth }
